module.exports = __webpack_public_path__ + "img/phone-generic.daab914.png";